import ButtonLock from './button-lock';

export default ButtonLock;